import { useCurrentUserId } from '@framework/auth';
import { useSnapshot } from '@framework/hooks/useSnapshot';
import { RTDBPath } from 'balus-common';
import { UserEntity } from './UserEntity';

/**
 * 現在ログイン中ユーザが Levii 社員かどうかを返します。
 * 匿名ユーザの場合には false が返ります。
 *
 * @returns
 */
export const useCurrentUserIsLeviiStaff = (): boolean => {
  const currentUserId = useCurrentUserId();

  const [currentUser] = useSnapshot<UserEntity | null>({
    path: RTDBPath.User.userEntityPath(currentUserId || ''),
    load: ({ snapshot }) => (snapshot.exists() ? UserEntity.load(snapshot.val()) : null),
    skip: typeof currentUserId !== 'string',
  });

  return !!currentUser?.isLeviiDomain();
};
